// Page liste des articles du blog

import { useState } from "react";
import { LandingHeader, LandingFooter } from "@/components/landing";
import { BlogHero, BlogFilters, BlogCard } from "@/components/blog";
import { articles, getArticlesByCategory, CategoryType } from "@/data/articles";
import { usePageMeta } from "@/hooks/usePageMeta";
import { JsonLd } from "@/components/seo/JsonLd";

const Blog = () => {
  const [activeCategory, setActiveCategory] = useState<CategoryType>('Tous');

  usePageMeta({
    title: "Blog B8ild — Conseils gestion chantier BTP",
    description: "Articles, guides et conseils pour améliorer la rentabilité de vos chantiers BTP. Marges, trésorerie, gestion d'équipe.",
    url: "https://b8ild.fr/blog",
  });

  const filteredArticles = getArticlesByCategory(activeCategory);

  return (
    <div className="min-h-screen bg-[#0F172A]">
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Blog B8ild — Conseils gestion chantier BTP",
        description: "Articles, guides et conseils pour améliorer la rentabilité de vos chantiers BTP.",
        url: "https://b8ild.fr/blog",
        isPartOf: { "@type": "WebSite", name: "B8ild", url: "https://b8ild.fr" },
        inLanguage: "fr",
      }} />
      <LandingHeader />

      <main>
        {/* Hero */}
        <BlogHero />

        {/* Filtres */}
        <BlogFilters
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Grille d'articles */}
        <section className="py-12 bg-[#0F172A]">
          <div className="container mx-auto px-4">
            {filteredArticles.length > 0 ? (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredArticles.map((article) => (
                  <BlogCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-white/50">
                  Aucun article dans cette categorie pour le moment.
                </p>
              </div>
            )}
          </div>
        </section>
      </main>

      <LandingFooter />
    </div>
  );
};

export default Blog;
